/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_German_English13Inputs */

const en__field_enum_german_english13 = /** @type {(inputs: _Field_Enum_German_English13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German and English`)
};

const de__field_enum_german_english13 = /** @type {(inputs: _Field_Enum_German_English13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch und Englisch`)
};

/**
* | output |
* | --- |
* | "German and English" |
*
* @param {_Field_Enum_German_English13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_german_english13 = /** @type {((inputs?: _Field_Enum_German_English13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_German_English13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_german_english13(inputs)
	return de__field_enum_german_english13(inputs)
});
export { _field_enum_german_english13 as "_field_enum_GERMAN_ENGLISH" }